import { concat } from "lodash";

import routerDriver from "./driver";
import routerClients from "./clients";
import routerDeliveryPoints from "./delivery_points";
import routerTransport from "./transport";
import routerOperators from "./operators";
import routerZones from "./zones";
import routerInvoices from "./invoices";
import routerSuppliers from "./suppliers";
import routerOCBinnacle from "./binnacleoc";
import routerFuel from "./fuel";

import Masters from "../../../../pages/Masters";

const routesMasters = [{ key: "masters", path: "/masters", element: <Masters />, }]

const routes = concat(
    routesMasters,
    routerDriver,
    routerClients,
    routerDeliveryPoints,
    routerTransport,
    routerOperators,
    routerZones,
    routerInvoices,
    routerSuppliers,
    routerOCBinnacle,
    routerFuel
)

export default routes